import { Component, EventEmitter, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { CommonModule, SlicePipe } from '@angular/common';
import { AuthService } from '@/pages/service/auth.service';
import { UsersService } from '@/modules/users/services/users/users.service';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { FotoPerfilComponent } from '@/shared/components/foto-perfil/foto-perfil.component';
import { NotificacionesInvitacionService } from '@/shared/services/notificaciones-invitacion.service';

@Component({
    selector: 'app-hader-user',
    templateUrl: './hader-user.component.html',
    styleUrls: ['./hader-user.component.css'],
    imports: [CommonModule, ButtonModule, TooltipModule, DialogModule, ProgressSpinnerModule, ToastModule, SlicePipe, FotoPerfilComponent],
    providers: [MessageService]
})
export class HaderUserComponent {
    @Input() photoUrl: string | null = null;
    @Input() photoUploading = false;
    @Output() photoUpdated = new EventEmitter<string>();

    @ViewChild('fileInput') fileInputRef!: ElementRef<HTMLInputElement>;

    userAuth: any | null = null;
    copiado: boolean = false;
    showPhotoModal = false;
    isUploading = false;

    constructor(
        private readonly authService: AuthService,
        private readonly usersService: UsersService,
        private readonly messageService: MessageService,
        private readonly router: Router,
        private readonly notificacionesService: NotificacionesInvitacionService
    ) {
        this.userAuth = this.authService.user ? JSON.parse(this.authService.user) : null;
        if (this.photoUrl === null && this.userAuth?.foto_perfil_url) {
            this.photoUrl = this.userAuth.foto_perfil_url;
        }
    }

    openPhotoModal(): void {
        if (this.photoUrl) {
            this.showPhotoModal = true;
        }
    }

    onFotoPerfilUpdated(url: string): void {
        this.photoUrl = url;
        this.userAuth = { ...this.userAuth, foto_perfil_url: url };
        this.authService.user = JSON.stringify(this.userAuth);
        this.photoUpdated.emit(url);
    }

    triggerFileInput(): void {
        this.fileInputRef.nativeElement.click();
    }

    onFileSelected(event: Event): void {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0];
        if (!file) return;

        this.isUploading = true;

        this.usersService.uploadProfilePhoto(this.userAuth.id, file).subscribe({
            next: (response: any) => {
                let url: string = response?.data?.foto_perfil_url ?? '';
                if (url) {
                    const backendOrigin = new URL(environment.apiBack).origin;
                    url = url.replace(/^https?:\/\/[^/]+/, backendOrigin);
                }
                this.photoUrl = url;
                this.userAuth = { ...this.userAuth, foto_perfil_url: url };
                this.authService.user = JSON.stringify(this.userAuth);
                this.photoUpdated.emit(url);
                this.messageService.add({
                    severity: 'success',
                    summary: 'Foto actualizada',
                    detail: 'Tu foto de perfil se actualizó correctamente',
                    life: 3000
                });
                this.showPhotoModal = false;
            },
            error: () => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'No se pudo actualizar la foto de perfil',
                    life: 5000
                });
            },
            complete: () => {
                this.isUploading = false;
                input.value = '';
            }
        });
    }

    copiarCodigo() {
        navigator.clipboard.writeText(this.userAuth.codigo_entidad).then(() => {
            this.copiado = true;
            setTimeout(() => (this.copiado = false), 2000);
        });
    }

    logout() {
        this.notificacionesService.detener();
        this.authService.logout().subscribe({
            next: () => {
                this.router.navigate(['/auth/login']);
            },
            error: (error) => {
                console.error('Error al cerrar sesión', error);
            }
        });
    }
}
